import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { NgfAttachmentsListModule, ScannedDocument } from '@fina-dot-net/ngf-attachments-list';
import { SysConfigService } from '../../../../../../../core/src/lib/services/sys-config.service';

@Component({
  selector: 'app-attachment-list',
  imports: [NgfAttachmentsListModule],
  templateUrl: './attachment-list.component.html',
  styleUrl: './attachment-list.component.scss',
})
export class AttachmentListComponent {
  private route = inject(ActivatedRoute);
  _sysConfigService = inject(SysConfigService);

  private data = toSignal(this.route.data);

  scannedDocuments = computed(() => this.data()!['attachements'] as any);

  realDocs: ScannedDocument[] = [];

  ngOnInit() {
    var link = this._sysConfigService.SysConfig?.HomeUrl;
    this.realDocs = this.scannedDocuments().ExistingDocuments;
    this.realDocs.forEach((x) => {
      x.PreviewLink = '/';
    });
  }
}
